import { useSponsors } from '@/lib/hooks'
import { SponsorsStrip } from '@/components/sections/SponsorsStrip'
import { PageHero } from '@/components/layout/PageHero'
import { Heart } from 'lucide-react'

export function SponsorsPage() {
  const { data } = useSponsors()
  if (!data) return null
  return (
    <>
      <PageHero
        eyebrow="Partners &amp; Community"
        title="Sponsors &amp; Donors."
        intro="Cosmos F.C. is grateful to the organizations and individuals who make our programming possible."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/COSHD.jpg"
        crumbs={[{ label: 'Sponsors' }]}
      />
      <section className="py-20">
        <div className="container-narrow">
          <div className="mb-16">
            <h2 className="font-display text-2xl uppercase mb-4">Our Sponsors</h2>
            <SponsorsStrip sponsors={data.sponsors} />
          </div>

          <div>
            <h2 className="font-display text-2xl uppercase mb-4 flex items-center gap-3">
              <Heart className="h-5 w-5 text-cosmos-gold" />
              Individual Donors
            </h2>
            <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
              {data.donors.map((d) => (
                <div key={d.name} className="rounded-lg border border-border bg-card p-4">
                  <div className="font-display text-base uppercase">{d.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">{d.location}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
